import { Table } from '@/components/package/table'

export const Index = () => {
  return (
    <>
      <div className="flex flex-col gap-12">
        <Table pageSize={15} createable onIndex />
      </div>
    </>
  )
}
